import { SmartpostParcelMachine } from '../types/shipping';

export type { SmartpostParcelMachine };
// Get Supabase URL and Anon Key from environment variables
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export async function fetchSmartpostLocations(): Promise<SmartpostParcelMachine[]> {
  try {
    // Call the Supabase Edge Function for Smartpost lockers
    const response = await fetch(`${SUPABASE_URL}/functions/v1/smartpost-lockers`, {
      headers: {
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch Smartpost parcel machines from Supabase Edge Function');
    }
    
    const data = await response.json();
    
    // The Edge Function already returns data in the desired format, so no further mapping needed here
    return data;
  } catch (error) {
    console.error('Error fetching Smartpost parcel machines:', error);
    return [];
  }
}